<div class="chart" [style.width.px]="width" [style.height.px]="height">
    <div class="chart-value">{{descriptionText}}</div>
    <canvas class="canvas-element" baseChart [data]="doughnutChartData" [type]="doughnutChartType"></canvas>
</div>